import { watch } from 'vue';

import { useFormData } from '@/composables/formData';

export function usePromoCode() {
    const { state, reset } = useFormData({
        code: '',
        capture: '',
        hint: '',
        error: '',
    });

    watch(() => state.data.code, () => {
        if (!state.data.code) {
            reset();
        }
    });

    return {
        state,
    };
}
